// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/propeller-pitch.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/propeller-pitch/propeller-pitch.js';

mount([g0]);
